import { defineStore } from 'pinia'

import { createEcommerceOrdersActions } from './actions'
import { createEcommerceOrdersState } from './state'

export const useEcommerceOrdersStore = defineStore('ecommerceOrders', () => {
    const state = createEcommerceOrdersState()
    const actions = createEcommerceOrdersActions(state)

    return {
        ...state,
        ...actions
    }
})
